import { LeavingPageAlertPopup } from './LeavingPageAlertPopup';

export default LeavingPageAlertPopup;
